import { round } from "./numberUtil";

const toUiVersion = version => {
    if (!isNaN(version)) {
        const majorVersion = version === 0 ? 0 : Math.trunc(version);

        let minorVersion;
        if (version < 1) {
            minorVersion = version * 1000;
        } else {
            minorVersion = round(version % majorVersion, 3) * 1000;
        }

        return `${majorVersion}.${minorVersion}`
    }

    throw "Version is not a number.";
}

export {
    toUiVersion
}